module.exports = __webpack_public_path__ + "static/payment-d7e08204b51f89d8dab819ad1cdefee2.png";